<template>
  <div class="bg">
    <headline :params="headLines" />
    <div class="container">
      <div class="content">
        <article :class="{center: history_id}">
          <div class="top">
            <div class="title">
              <h4 v-if="detail">{{detail.report_title}}</h4>
              <div class="aux">
                <span v-if="detail.has_translate_role">英译中 <div class="tips">该翻译由系统自动生成，仅供参考</div></span>
                <span :class="{up: showVersions}" @click="toggleVersions()">
                  历史版本
                  <p class="history" v-show="showVersions" v-if="history.length > 0">
                    <i class="line" :style="{height: `${(history.length-1) * 50}px`}"></i>
                    <i class="head">
                      <i class="topic">历史版本时间</i>
                      <i class="user">操作人</i>
                    </i>
                    <i class="i" v-for="(h, j) in history" :key="j" @click.stop="chooseVersion(h)">
                      <i :class="{dot: true, g:h.history_id == history_id}"></i>
                      <i class="title">{{h.raw_add_time}}</i>
                      <i class="time">{{h.user_name}}</i>
                    </i>
                  </p>
                </span>
              </div>
            </div>
            <div class="date">
              <label v-if="detail" :class="{card: detail.uid != 0}" @click="showCard(detail.uid, $event)">
                {{detail.user_name}}
              </label>
              <span v-if="detail">{{detail.raw_update_time}}</span>
            </div>
            <div class="sub">
              <label>创建部门：</label>
              <span>{{detail.depart_title || '无'}}</span>
              <label>发送平台：</label>
              <span>{{detail.push_platform || '无'}}</span>
              <label>信源：</label>
              <span>{{(detail.source_info && detail.source_info.ptitle) || '无'}}</span>
              <label>频道：</label>
              <span>{{(detail.source_info && detail.source_info.stitle) || '无'}}</span>
            </div>
          </div>
          <div class="warning" v-if="detail.warning_content">
            <img src="@assets/img/common/warn.svg" alt="warn">
            <div class="info">
              <div class="about">
                <span class="name">{{detail.warning_username}}</span>
                <span>{{detail.warning_addtime}}</span>
              </div>
              <div class="detail">
                {{detail.warning_content}}
              </div>
            </div>
          </div>
          <div class="infoBox">
            <div v-if="detail.type == 0" class="details" v-html="content" id="content"></div>
            <div v-else class="details editable">{{content}}</div>
            <div class="count" v-if="detail.type == 1">
              <label>正文：</label><span>{{bodyText.length}}字 {{Math.ceil(bodyDurantion)}}秒</span>
              <label>导语：</label><span>{{headText.length}}字 {{Math.ceil(headDurantion)}}秒</span>
              <label>语速：</label><span>{{speed}}字/分钟</span>
            </div>
            <div class="column">
              <ul>
                <li><label>记者</label>
                  <a href="#" @click.prevent="">{{detail.reporters}}</a>
                  <span v-if="!detail.reporters" class="no">无</span>
                </li>
                <li><label>摄像</label>
                  <a href="#" @click.prevent="">{{detail.cameras}}</a>
                  <span v-if="!detail.cameras" class="no">无</span>
                </li>
                <li v-if="!!detail.topicExist"><label>{{`所属${$_syscfg.topic}`}}</label>
                  <!-- <router-link :to="`/topicDetail?d=${detail.st_id}`">{{detail.st_title}}</router-link> -->
                  <a href="#" @click.prevent="goTopic()">{{detail.st_title}}</a>
                  <span v-if="!detail.st_title" class="no">无</span>
                </li>
                <li v-if="!!detail.interviewExist"><label>{{`来源${$_syscfg.interview}`}}</label>
                  <!-- <router-link :to="`/interviewDetail?r=${detail.iview_id}`">{{detail.iview_title}}</router-link> -->
                  <a href="#" @click.prevent="goItv()">{{detail.iview_title}}</a>
                  <span v-if="!detail.iview_title" class="no">无</span>
                </li>
                <li v-if="detail"><label>标签</label>
                  <small @click="goTags(item)" v-for="(item,index) in detail.tags" :key="index">{{item.title}}</small>
                  <span class="no" v-if="!detail.tags || detail.tags.length === 0">无</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="extendInfo" v-show="showExtendInfo">
            <div class="title">
              扩展信息
            </div>
            <div class="line">
              <div class="part">
                <span class="partTitle">
                  发生地点
                </span>
                <span class="partContent">
                  {{detail.hanppen_address}}
                </span>
              </div>
              <div class="part">
                <span class="partTitle">
                  发生时间
                </span>
                <span class="partContent">
                  {{detail.hanppen_time}}
                </span>
              </div>
            </div>
            <div class="line">
              <div class="part">
                <span class="partTitle">
                  发布时间
                </span>
                <span class="partContent">
                  {{detail.release_time}}
                </span>
              </div>
              <div class="part">
                <span class="partTitle">
                  抓取时间
                </span>
                <span class="partContent">
                  {{detail.grab_time}}
                </span>
              </div>
            </div>
            <div class="line">
              <div class="part">
                <span class="partTitle">
                  保密等级
                </span>
                <span class="partContent">
                  {{detail.secret_level}}
                </span>
              </div>
              <div class="part">
                <span class="partTitle">
                  收录时间
                </span>
                <span class="partContent">
                  {{detail.included_time}}
                </span>
              </div>
            </div>
            <div class="line">
              <div class="part">
                <span class="partTitle">
                  简介
                </span>
                <span class="partContent">
                  {{detail.info}}
                </span>
              </div>
            </div>
          </div>
          <div class="exender" @click="toggleExtendor()">
            <span>
              {{showExtendInfo?'收起扩展信息':'查看扩展信息'}}
            </span>
            <img :src="showExtendInfo?icons.upGreen:icons.downGreen" alt="icons">
          </div>
        </article>
        <aside class="_xnsAside" v-show="!history_id">
          <div :class="{'aside-content': true, folded: !showMedia}">
            <p class="ptitle">
              <span>多媒体</span>
              <span class="right" @click="toggleMedia()">
                {{(detail.img_list && detail.img_list.length) + (detail.video_list && detail.video_list.length) + (detail.sound_list && detail.sound_list.length) + (detail.file_list && detail.file_list.length)}}
                <img :src="showMedia?icons.up:icons.down" alt="icons">
              </span>
            </p>
            <div class="nav" v-show="showMedia">
              <ul>
                <li :class="{active:navOn==0}" @click="navSwitch(0)">图片 <span>{{detail.img_list && detail.img_list.length}}</span></li>
                <li :class="{active:navOn==1}" @click="navSwitch(1)">视频 <span>{{detail.video_list && detail.video_list.length}}</span></li>
                <li :class="{active:navOn==2}" @click="navSwitch(2)">音频 <span>{{detail.sound_list && detail.sound_list.length}}</span></li>
                <!-- <li :class="{active:navOn==3}" @click="navSwitch(3)">文件 <span>{{detail.file_list && detail.file_list.length}}</span></li> -->
              </ul>
            </div>
            <div class="nav-content" v-show="showMedia">
              <div class="nav-item" v-if="navOn==0">
                <empty :msg="'暂无图片'" v-if="detail.img_list && detail.img_list.length === 0" />
                <div class="item" v-for="(img, index) in detail.img_list" :key="index">
                  <ul>
                    <li class="thum" @mouseenter='zoomIn' @mouseleave='zoomOut' @click="goViewer(detail, img)">
                      <img class="cover" :src="img.cover || defaultImg" alt="cover">
                    </li>
                    <li class="title">
                      <h4>{{img.title}}</h4>
                    </li>
                    <li v-if="showDownload" class="down">
                      <span @click="downloadSource(img)"></span>
                    </li>
                  </ul>
                  <dl>
                    <li><label>格式</label>{{img['content'].type}}</li>
                    <li><label>大小</label>{{img['content'].size}}</li>
                    <li><label>尺寸</label>{{img['content'].pixel}}</li>
                    <!-- <li><label>分辨率</label>{{img['content'].resolution}}</li>
                          <li><label>码率</label>{{img['content'].rate}}</li> -->
                  </dl>
                </div>
              </div>
              <div class="nav-item" v-if="navOn==1">
                <empty :msg="'暂无视频'" v-if="detail.video_list && detail.video_list.length === 0" />
                <div class="item" v-for="(img, index) in detail.video_list" :key="index">
                  <ul>
                    <li class="thum" @mouseenter='zoomIn' @mouseleave='zoomOut' @click="goViewer(detail, img)">
                      <img class="cover" :src="img['content']?(img['content'].cover || defaultMedia):defaultMedia" alt="cover">
                      <img src="@assets/img/common/play.svg" alt="play" class="play">
                    </li>
                    <li class="title">
                      <h4>{{img.title}}</h4>
                    </li>
                    <li v-if="showDownload" class="down">
                      <span @click="toggleD(img,$event)">
                        <div style="z-index:100;" class="dOptions" v-if="img.showD">
                          <p :class="{'disableD': !detail.has_low_quality_download_role || img.content.status != 1}" @click="downloadSource(img, 0)">
                            <img src="@assets/img/common/800k.svg" alt="800k">
                            <i>800K码流</i>
                          </p>
                          <p :class="{'disableD': !detail.has_high_quality_download_role || !img.download_url}" @click="downloadSource(img, 1)">
                            <img src="@assets/img/common/HD.svg" alt="HD">
                            <i>原始码流</i>
                          </p>
                        </div>
                      </span>
                    </li>
                  </ul>
                  <dl>
                    <li><label>格式</label>{{img['content']?img['content'].format:''}}</li>
                    <li><label>时长</label>{{img['content']?img['content'].duration:''}}</li>
                    <li><label>码率</label>{{img['content']?img['content'].rate:''}}</li>
                    <li><label>大小</label>{{img['content']?img['content'].file_size:''}}</li>
                    <li><label>尺寸</label>{{img['content']?img['content'].resolution:''}}</li>
                  </dl>
                  <div class="btn" v-if="detail.has_pickup_text_role">
                    <div class="text half" v-if="img.text_status == 1" @click="convertWord(img)">视频语音转文字</div>
                    <div class="text half" v-if="img.text_status == 2"><img src="@assets/img/common/loading-g.svg" alt="loading" />转码中</div>
                    <div class="text half" v-if="img.text_status == 3" @click="goWord(img.idstring, 'video')">查看文字</div>
                    <div class="text half fail" v-if="img.text_status == 4" @click="convertWord(img)" @mouseover.stop="hoverFailBtn(img, true)" @mouseout.stop="hoverFailBtn(img, false)">
                      {{img.hover?'视频语音转文字':'转码失败'}}</div>
                    <div class="text half" @click="goInPicture(img)">
                      进入画中画
                    </div>
                  </div>
                </div>
              </div>
              <div class="nav-item" v-if="navOn==2">
                <empty :msg="'暂无音频'" v-if="detail.sound_list && detail.sound_list.length === 0" />
                <div class="item" v-for="(img, index) in detail.sound_list" :key="index">
                  <ul>
                    <li class="thum" @mouseenter='zoomIn' @mouseleave='zoomOut' @click="goViewer(detail, img)">
                      <img class="cover" :src="img['content']?(img['content'].cover || defaultMedia):defaultMedia" alt="cover">
                    </li>
                    <li class="title">
                      <h4>{{img.title}}</h4>
                    </li>
                    <li v-if="showDownload" class="down">
                      <span @click="toggleD(img,$event)">
                        <div style="z-index:100;" class="dOptions" v-if="img.showD">
                          <p :class="{'disableD': !detail.has_low_quality_download_role || img.content.status != 1}" @click="downloadSource(img, 0)">
                            <img src="@assets/img/common/800k.svg" alt="800k">
                            <i>800K码流</i>
                          </p>
                          <p :class="{'disableD': !detail.has_high_quality_download_role || !img.download_url}" @click="downloadSource(img, 1)">
                            <img src="@assets/img/common/HD.svg" alt="HD">
                            <i>原始码流</i>
                          </p>
                        </div>
                      </span>
                    </li>
                  </ul>
                  <dl>
                    <li><label>格式</label>{{img['content']?img['content'].format:''}}</li>
                    <li><label>时长</label>{{img['content']?img['content'].duration:''}}</li>
                    <li><label>声道</label>{{img['content']?img['content'].track:''}}</li>
                    <li><label>码率</label>{{img['content']?img['content'].rate:''}}</li>
                    <li><label>大小</label>{{img['content']?img['content'].file_size:''}}</li>
                  </dl>
                  <div class="btn" v-if="detail.has_pickup_text_role">
                    <div class="text" v-if="img.text_status == 1" @click="convertWord(img)">音频语音转文字</div>
                    <div class="text" v-if="img.text_status == 2"><img src="@assets/img/common/loading-g.svg" alt="loading" />转码中</div>
                    <div class="text" v-if="img.text_status == 3" @click="goWord(img.idstring, 'audio')">查看文字</div>
                    <div class="text fail" v-if="img.text_status == 4" @click="convertWord(img)" @mouseover.stop="hoverFailBtn(img, true)" @mouseout.stop="hoverFailBtn(img, false)">
                      {{img.hover?'音频语音转文字':'转码失败'}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div :class="{'aside-content mt': true, folded: showMedia}" v-if="!!detail.materialExist">
            <p class="ptitle">
              <span>{{`关联${$_syscfg.clue}`}}</span>
              <span class="right" @click="toggleMedia()">
                {{(detail.materials || []).length}}
                <img :src="showMedia?icons.down:icons.up" alt="icons">
              </span>
            </p>
            <div class="nav-content" v-show="!showMedia">
              <div class="nav-item">
                <empty :msg="'暂无线索'" v-if="detail.materials && detail.materials.length === 0" />
                <div class="item clue" v-for="(img, index) in detail.materials" @click="goClueDetail(img.material_id)" :key="index">
                  <!-- todo  -->
                  <ul>
                    <li class="thum"><img class="cover" :src="img.material_img || defaultImg" alt=""></li>
                    <li class="title">
                      <h4>{{img.material_title}}</h4>
                    </li>
                  </ul>
                  <dl class="mcontent">
                    {{img.material_content}}
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>
      <footer v-if="!history_id">
        <li class="button white left">
          <button :class="{g: !reportLog, l: true}" @click="reportList">{{`${$_syscfg.report}的一生`}}</button>
          <button v-if="isCheck" class="w" @click="goEdit()">编辑</button>
          <button v-if="detail.has_push && !isCheck" class="b" @click="pushTo()">发送至</button>
          <button v-if="isCheck" class="b" @click="handleReport(0)">通过</button>
          <button v-if="detail.has_kankan" class="w" @click="pushKK()">送看看</button>
          <button v-if="isCheck" class="w" @click="handleReport(1)">退回</button>
          <button v-if="detail.has_copy" class="w" @click="copyReport()">转发</button>
          <button v-if="detail.has_publish" class="w" @click="pushPublish(detail.report_id, 'report')">{{`推送${$_syscfg.publish}`}}</button>
          <button v-if="detail.has_download_role && !isCheck" class="w" @click="download()">下载文稿</button>
        </li>
        <!-- 报道一生 -->
        <div class="reportList" v-if="reportLog && life.length > 0">
          <ul class="stages">
            <div class="progress" :style="{height: `${progressH}px`}"></div>
            <li v-for="(l, i) in life" :key="i">
              <label :class="{current: i === 0}">{{l.action}}</label>
              <p>
                <span class="time">{{l.raw_add_time}}</span>
                <span class="name">{{l.opt_username}}</span>
                <span :class="{time: true, success: l.action_color == 1, return: l.action_color == 2}">{{l.type}}</span>
              </p>
            </li>
          </ul>
        </div>
        <div class="right button">
          <button class="yellow" @click="showWarning()">{{`${detail.warning_content?'编辑':'添加'}警示`}}</button>
        </div>
      </footer>
    </div>
    <pushBox ref="pushBox" />
  </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import headline from "@components/headline";
import dc from "@common/dc";
import empty from "@components/empty";
import pushBox from "@components/pushBox";
import Vue from "vue";

export default {
  components: {
    headline,
    empty,
    pushBox
  },
  computed: {
    quickEdit() {
      return this.$store.state.quickEdit;
    }
  },
  watch: {
    "$store.state.flashPic1": function (el) {
      if (el) {
        this.getData();
        this.$store.commit("setflashPic1", false);
      }
    },
    $route(to, from) {
      this.getPageVersion();
    }
  },
  data() {
    return {
      isXnew: this.$store.state.isXnew,
      headLines: {
        title: "",
        showLink: false,
        filter: false
      },
      icons: {
        up: require("@assets/img/common/upward.svg"),
        down: require("@assets/img/common/xiala.svg"),
        upGreen: require("@assets/img/common/upward_green.svg"),
        downGreen: require("@assets/img/common/downward_green.svg")
      },
      defaultImg: require("@assets/img/common/default.png"),
      defaultMedia: require("@assets/img/common/defaultMedia.png"),
      defaultAudio: require("@assets/img/common/defaultAudio.png"),
      showMedia: true,
      detail: {},
      navOn: 0,
      isDialog: false,
      fileType: false,
      reportLog: false,
      report_id: null,
      life: [],
      showVersions: false,
      history: [],
      history_id: "",
      speed: 0,
      bodyText: "", // 正文纯文字
      headText: "", // 导语纯文字
      bodyDurantion: 0, // 正文时长
      headDurantion: 0, // 导语时长
      isCheck: false,
      showDownload: false,
      content: "",
      showExtendInfo: false,
      progressH: 0
    };
  },
  methods: {
    zoomIn(e) {
      let item = e.target;
      let children = item.children;
      let cover = '';
      for (let child of children) {
        if (child.classList.contains("cover")) {
          cover = child;
        }
      }
      cover.classList.add("zoom");
    },
    zoomOut(e) {
      let item = e.target;
      let children = item.children;
      let cover = '';
      for (let child of children) {
        if (child.classList.contains("cover")) {
          cover = child;
        }
      }
      cover.classList.remove("zoom");
    },
    /**
     * 选用 为快编素材
     */
    addQKFile({ id }, type) {
      console.log("addQKFile  file id", id);
      console.log("addQKFile type", type);
      let data = {
        file_ids: id
      };
      common.myFetch(apis.File_addquickfile, data).then(res => {
        console.log("File_addquickfile res", res);
        if (res) {
          this.$toast("已成功加入选用素材");
        }
      });
    },
    async pushPublish(id, t) {
      // 推送发布
      const type = await this.$pageType("publish");
      if (!type) return;

      const info = {
        subject_id: this.$route.query.d,
        subject_type: t,
        type: type
      };

      common.myFetch(apis.publish_pushPublish, info).then(r => {
        if (r) {
          const url = `/editPublish?d=${r.id}`;

          common.jump(url, true);
        }
      });
    },
    showWarning() {
      // 唤起警示窗口
      const content = {
        id: this.$route.query.d,
        type: 1,
        msg: this.detail.warning_content
      };

      this.$warning(content).then(r => {
        if (r) {
          this.getData();
        }
      });
    },
    showCard(id, e) {
      if (id == 0) return;

      const el = e.target;

      this.$card(id, el);
    },
    toggleExtendor() {
      this.showExtendInfo = !this.showExtendInfo;
    },
    goInPicture(item) {
      if (!item.content || item.content.status != 1) {
        this.$toast("转码中，暂时无法进入画中画");
        return;
      }

      this.$miniPicture(item.url);
    },
    async copyReport() {
      // 转发报道
      const id = this.$route.query.d;
      const type = await this.$pageType();

      if (!type) return;

      const info = {
        report_id: id,
        type: type
      };
      const newWindow = window.open();

      common.myFetch(apis.Rpt_copy, info).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin
            }/editReport?d=${r.report_id}`;
        }
      });
    },
    hoverFailBtn(item, status) {
      // 转码失败按钮鼠标事件
      this.$set(item, "hover", status);
    },
    toggleD(i, e) {
      const el = e.target;
      let query = this.$route.query.d;
      this.$DownloadBtn(1, query, this.detail, i, el);
      // this.$set(i, 'showD', !i.showD)
    },
    async goEdit() {
      const id = this.$route.query.d;
      const checked = await common.checkPageStatus(id, 1);
      if (!checked) return;

      common.jump(`/editReport?d=${id}`, false);
    },
    checkType() {
      // 检查页面类型：详情 ／ 审核详情
      const c = this.$route.query.c;
      if (c) {
        this.isCheck = true;
        this.headLines.title = `${this.$_syscfg.report}审核`;
      } else {
        this.headLines.title = `${this.$_syscfg.report}详情`;
      }
    },
    async handleReport(status) {
      // 审核／退回报道
      let msg = `确定通过${this.$_syscfg.report}吗？`;
      if (status === 1) {
        msg = `确定退回${this.$_syscfg.report}吗? `;
      }
      const confirm = await this.$confirm(msg);
      if (!confirm) return;

      const id = this.$route.query.d;
      let info = {
        report_id: id,
        status: status
      };

      common.myFetch(apis.Rpt_handle_report, info).then(res => {
        if (res) {
          this.$toast(res);

          window.close();
        }
      });
    },
    goClueDetail(id) {
      // 跳转线索详情
      if (!this.detail.has_material_detail_role) return;

      common.jump(`/clueDetail?d=${id}`, true);
    },
    goTopic() {
      if (this.detail.st_is_delete == 1 || !this.detail.has_topic_role) return;

      this.$router.push({
        path: "/topicDetail",
        query: {
          d: this.detail.st_id
        }
      });
    },
    goItv() {
      if (!this.detail.has_interview_role) return;

      this.$router.push({
        path: "/interviewDetail",
        query: {
          r: this.detail.iview_id
        }
      });
    },
    watchContent(c) {
      // 检测内容变化
      const bodyText = common.getBody(c);
      const headText = common.getLead(c);

      this.bodyText = common.replacePunctuations(bodyText);
      this.headText = common.replacePunctuations(headText);
      this.calculateText();
    },
    calculateText() {
      // 计算时长
      const gap = 60 / this.speed;
      this.bodyDurantion = gap * this.bodyText.length;
      this.headDurantion = gap * this.headText.length;
    },
    goTags(i) {
      // 跳转自采线索并选中标签
      this.$router.push({
        name: "reports",
        params: {
          tag: i.title
        }
      });
    },
    async goViewer({ img_list, video_list, sound_list }, item) {
      console.log("item", item);
      let config = {
        type: item.type,
        id: item.id,
        quickEdit: this.quickEdit,
        create: this.$store.state.create,
        canEdit: true,
        t: Number(1),
        d: this.$route.query.d
      };
      console.log("config", config);
      let list = [
        ...img_list,
        ...video_list.filter(e => e.content.status == 1),
        ...sound_list.filter(e => e.content.status == 1)
      ];
      // list 有id即可
      let index = list.findIndex(e => e.id == item.id);
      this.$materialBox(config, null, {
        index,
        list,
        quickEdit: this.quickEdit,
        create: this.$store.state.create,
        canEdit: false,
        t: Number(1),
        d: this.$route.query.d
      });
    },
    goViewer1(data, item) {
      if (item.type != 1 && (!item.content || item.content.status != 1)) {
        this.$toast("转码中，暂时无法预览");
        return;
      }

      const now = {
        url: item.url,
        type: item.type - 0,
        downloadUrl: item.download_url
      };

      common.viewMedia(data, now);
    },
    getMedias() {
      // 获取内部媒体：图片／视频，并使用浏览器打开
      const content = document.getElementById("content");
      const imgs = content.getElementsByTagName("img");
      const videos = content.getElementsByTagName("video");
      const imglist = Array.from(imgs).map(i => i.src);

      for (let i of imgs) {
        i.addEventListener("click", () => {
          this.openViewer(imglist, i.src, "img");
        });
      }

      for (let v of videos) {
        v.addEventListener("click", () => {
          this.openViewer(
            videos,
            { url: i.src, downloadUrl: i.src, idstring: "" },
            "video"
          );
        });
      }
    },
    openViewer(list, src, type) {
      this.$viewer(list, src, type);
    },
    chooseVersion(i) {
      // 选择历史版本
      // const info = {
      //   history_id: i.history_id
      // }

      // common.myFetch(apis.Rpt_history, info)
      // .then(r => {
      //   if (r) {
      //     this.detail = r.detail
      //     this.history_id = r.detail.history_id

      //     this.speed = this.detail.content_speed || 0
      //     let content = this.detail.content
      //     if (this.detail.type == 0) {
      //       content = common.replaceN2Br(content)
      //     }
      //     this.content = content
      //     this.watchContent(this.detail.content)

      //     this.$nextTick(() => {
      //       common.formatXNSAudios()
      //       common.handlePageMediaCenterPosition()
      //     })
      //   }
      // })

      this.showVersions = false;

      this.$router.push({
        path: "/reportDetail",
        query: {
          d: this.$route.query.d,
          h: i.history_id
        }
      });
    },
    toVersion(info) {
      // 获取特定版本数据并渲染
      const emptyPage =
        '<img class="noContent" src="static/assets/img/emptyPage.svg" alt="empty">';

      common.myFetch(apis.Rpt_history, info).then(r => {
        if (r) {
          this.detail = r.detail;
          this.history_id = r.detail.history_id;

          this.speed = this.detail.content_speed || 0;
          let content = this.detail.content;
          if (this.detail.type == 0) {
            content = common.replaceN2Br(content);
            content = content || emptyPage;
          }
          this.content = content;
          this.watchContent(this.detail.content);

          this.$nextTick(() => {
            common.formatXNSAudios();
            common.handlePageMediaCenterPosition();
          });
        }
      });
    },
    toggleVersions() {
      this.showVersions = !this.showVersions;
    },
    downloadSource(source, type) {
      if (type === 0) {
        if (!this.detail.has_low_quality_download_role) {
          this.$toast("无下载权限");
          return;
        } else {
          if (source.content.status != 1) {
            this.$toast("转码尚未完成");
            return;
          }
        }
      } else if (type === 1) {
        if (!this.detail.has_high_quality_download_role) {
          this.$toast("无下载权限");
          return;
        }
      }

      const info = {
        idstring: source.idstring,
        file_quality: type || 0,
        subject_type: 1,
        subject_id: this.$route.query.d
      };
      const url = apis.File_download;
      const userKeys = common.userKeys();
      const params = Object.assign({}, info, userKeys);

      common.exportRes(url, params, 1);
    },
    goWord(idstring, type) {
      let url = `/videotoword?d=${idstring}`;
      if (type === "audio") {
        url = `/audiotoword?d=${idstring}`;
      }

      common.jump(url, true);
    },
    convertWord(f) {
      // 音视频转文字
      if (!f.content || f.content.status != 1) {
        this.$toast("转码中，暂时无法转文字");
        return;
      }

      const info = {
        idstring: f.idstring
      };

      common.myFetch(apis.File_convert, info).then(r => {
        if (r) {
          this.$toast(r);

          this.$set(f, "text_status", 2);
        }
      });
    },
    download() {
      const info = {
        report_id: this.$route.query.d
      };

      const userKeys = common.userKeys();
      const params = Object.assign({}, info, userKeys);
      const url = apis.down_report;

      common.exportRes(url, params);
    },
    async pushKK() {
      const id = this.$route.query.d;
      // const config = {
      //   msg: "是否添加knews套件？",
      //   alpha: {
      //     title: "添加",
      //     handle: () => {
      //       this.postKK(id, 1);
      //     }
      //   },
      //   beta: {
      //     title: "不添加",
      //     handle: () => {
      //       this.postKK(id, 0);
      //     }
      //   }
      // };

      // this.$ask(config);

      const config = {
        id: id
      }

      this.$kkType(config).then((res) => {
        if(res!=999){
          this.postKK(id, res)
        }
      })
    },
    postKK: (id, type) => {
      const info = {
        report_id: id,
        three: type
      };

      common.myFetch(apis.toKK, info).then(r => {
        if (r) {
          Vue.prototype.$toast(r);
        }
      });
    },
    pushTo() {
      const id = this.$route.query.d;

      this.$refs.pushBox.open(id);
    },
    toggleMedia() {
      this.showMedia = !this.showMedia;
    },
    goReport() {
      const clue = {
        id: this.$route.query.d,
        title: this.detail.title
      };

      dc.setClue(clue);
      common.jump("/creatReport", true);
    },
    navSwitch(n) {
      this.navOn = n;
      // this.getData()
    },
    dialog() {
      this.isDialog = !this.isDialog;
    },
    reportList() {
      this.reportLog = !this.reportLog;

      if (this.reportLog) {
        this.$nextTick(() => {
          const container = document.querySelector(".stages");
          const stagesHeight = container.scrollHeight;
          this.progressH = stagesHeight;
        });
      }
    },
    getData() {
      const id = this.$route.query.d;
      const info = {
        report_id: id
      };
      const emptyPage =
        '<img class="noContent" src="static/assets/img/emptyPage.svg" alt="empty">';

      common.myFetch(apis.reportDetail, info).then(res => {
        if (res) {
          this.detail = res.detail;

          // 自动定位到第一项有内容的资源上
          if (this.detail.img_list.length === 0) {
            if (this.detail.video_list.length === 0) {
              if (this.detail.sound_list.length !== 0) {
                this.navSwitch(2);
              }
            } else {
              this.navSwitch(1);
            }
          }

          this.showDownload =
            this.detail.has_high_quality_download_role ||
            this.detail.has_low_quality_download_role;
          this.speed = this.detail.content_speed || 0;
          let content = this.detail.content;
          if (this.detail.type == 0) {
            content = common.replaceN2Br(content);
            // content = common.replaceBlank2NBSP(content)
            content = content || emptyPage;
          }
          this.content = content;
          this.watchContent(this.detail.content);

          this.$nextTick(() => {
            common.formatXNSAudios();
            common.handlePageMediaCenterPosition();
          });
        }
      });
    },
    getRptLife() {
      // 获取报道的一生
      const id = this.$route.query.d;
      const info = {
        report_id: id
      };

      common.myFetch(apis.Rpt_life, info).then(res => {
        if (res) {
          this.life = res.list;
        }
      });
    },
    getVersions() {
      // 获取历史版本号
      const id = this.$route.query.d;
      const info = {
        report_id: id,
        page: 1,
        pagesize: 50
      };

      common.myFetch(apis.Rpt_versions, info).then(r => {
        if (r) {
          this.history = r.list;
        }
      });
    },
    getTranstext(r) {
      // 获取转文字状态
      this.$toast("转文字完成");
      this.getData();
    },
    getTranscode(r) {
      // 获取转码通知
      const info = r.content;
      if (info) {
        this.$toast(`${info.title}已入库`);
        this.getData();
      }
    },
    getPageVersion() {
      // 根据url参数选择渲染当前或历史版本
      const h = this.$route.query.h;
      if (h) {
        const info = {
          history_id: h
        };

        this.toVersion(info);
      } else {
        this.history_id = null;

        this.getData();
      }
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    this.defaultMedia = this.$_syscfg.default_media
    this.checkType();
    // this.getData()
    this.getPageVersion();
    this.getRptLife();
    this.getVersions();
    common.handleSocket(this.getTranstext, "pickuptext");
    common.handleSocket(this.getTranscode, "transcode");
  },
};
</script>

<style src="@assets/css/mediaDetails/mediaDetails.less" lang="less" scoped>
</style>
